import { useApiClient } from '@startupquickstart/frontend';
import { useQuery } from '@tanstack/react-query';
import type { Tour } from '@/config/objects/tours';

/**
 * Hook to fetch tour data with themed content based on selected language
 * @param tourId - The tour ID
 * @param language - Optional language code (e.g., 'en', 'es', 'it')
 * @returns Query result with tour data including themed attractions
 */
export function useTourWithLanguage(tourId: string | undefined, language?: string) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['Tour', tourId, language],
    queryFn: async () => {
      if (!tourId) {
        throw new Error('Tour ID is required');
      }

      const url = language
        ? `/tours/${tourId}?language=${language}`
        : `/tours/${tourId}`;

      const result = await apiClient.get<{ data: Tour }>(url);
      return result.data;
    },
    enabled: !!tourId,
  });
}
